<template>
  <div class="auditLog">
    <v-row>
      <v-col cols="12">
        <div class="topPanel">
          <v-btn color="primary" class="mr-4" @click="loadLogData" :disabled="isAllDataLoaded">
            Load more data..
          </v-btn>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Filter"
            class="mb-2 search"
            single-line
            hide-details
          ></v-text-field>
        </div>
        <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page.sync="itemsPerPage"
          :footer-props="{ 'items-per-page-options': [20, 25, 50, 100] }"
          :loading="loading"
          :search="search"
          :calculate-widths="true"
          :page.sync="currentPage"
          item-key="LogID"
          loading-text="Loading log data..."
          class="auditLogTable"
          dense
        >
          <template v-slot:[`item.AuditDate`]="{ item }">
            <span>{{ item.AuditDateTime }}</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  components: {},
  name: 'AuditData',
  data() {
    return {
      loading: false,
      headers: [
        { text: 'Audit Date', value: 'AuditDate' },
        { text: 'Action', value: 'AuditType' },
        { text: 'User', value: 'UserName' },
        { text: 'Column', value: 'ColumnName' },
        { text: 'Old Value', value: 'OldValue' },
        { text: 'New Value', value: 'NewValue' },
      ],
      items: [],
      currentPage: 1,
      itemsPerPage: 20,
      search: null,
      isAllDataLoaded: false,
    };
  },
  computed: {},
  created() {
    this.loadLogData();
  },

  mounted: function () {
    this.$root.currentPage = 'AuditData';
  },

  methods: {
    async loadLogData() {
      this.loading = true;
      const startItemNumber = this.items.length + 1;
      const isNeedIncreasePage = this.currentPage == this.items.length / this.itemsPerPage;
      try {
        let response = await this.$api.get('security/GetAuditData?startAt=' + startItemNumber);
        if (response.data && response.data.length > 0) {
          this.items = this.items.concat(response.data);
          if (isNeedIncreasePage) this.currentPage++;
        } else {
          this.isAllDataLoaded = true;
        }
        this.loading = false;
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss">
.auditLog {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 30px;

  .topPanel {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .search {
    padding-top: 0px;
    max-width: 500px;
  }
  .v-data-table tbody tr {
    cursor: default;
  }
}
</style>
